import React from 'react';
import QDKSimulator from './components/QDKSimulator';

function App() {
    return (
        <div className="App">
            <QDKSimulator />
        </div>
    );
}

export default App;
